import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  departmentNode: {
    display: 'flex',
    paddingLeft: '20px',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    width: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
  },
  departmentHeader: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'flex-start',
    gap: anatomy['space-24'],
    width: '100%',
    alignSelf: 'stretch',
  },
  departmentArrow: {
    display: 'flex',
    width: '20px',
    height: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-10'],
  },
  departmentHeaderContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    gap: anatomy['space-8'],
    width: '100%',
  },
  departmentTitle: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
    color: colors.primaryText,
  },
  departmentChildren: {
    paddingLeft: '7px',
    gap: anatomy['space-12'],
    borderLeft: `1px solid ${colors.tertiaryBorder}`,
    width: '100%',
    boxSizing: 'border-box',
  },

  checkbox: {
    display: 'flex',
    alignItems: 'center',
  },

  chevronOpen: {
    transform: 'rotate(0deg)',
  },

  chevronClosed: {
    transform: 'rotate(-90deg)',
  },
});
